import * as z from "zod";

export const getOmsTiktokIntegration = {
  name: "getOmsTiktokIntegration" as const,
  input: z.object({}),
  output: z.object({ exists: z.boolean() }),
};
